function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#c74108;}.cls-2{fill:#b90000;}.cls-3{fill:#ffb80a;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M958.05,1053.78V195.46s4.88-22.7,52.92-22.7,41.17-32.73,41.17-41.7h26.92v35.37c0,17.95-34.92,40.12-69.15,40.12,0,0-39.59-1.06-39.59,36.95v810.28Z",
  transform: "translate(-493.9 -12.73)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M804,193.09v19.79s-1.32,65.72,59.39,65.72,94.62,28.51,94.62,28.51v-29.3c.62,1.19-28.56-22.52-91.46-27.71,0,0-29.29.79-29.29-57Z",
  transform: "translate(-493.9 -12.73)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M997.86,1053.78V665s6.86-72.59,77.07-72.59,86-27.18,86-71.52h27.72s18.74,99-113.76,99c0,0-46.19,7.92-46.19,49.09V781.4s65.81,6.07,76-38,7.92-76.8,31.68-100.56,53.84-24.54,78.39-24.54v34.05s-72.85-3.17-76,57-19.07,75.21-38.8,86.3-42,16.24-69.68,16.24v241.89Z",
  transform: "translate(-493.9 -12.73)"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 680.14,
  cy: 457.1,
  r: 55.03
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 752.68,
  cy: 619.55,
  r: 39.85
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 570.47,
  cy: 61.23,
  r: 61.23
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 324.39,
  cy: 115.08,
  r: 70.21
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M627.47,669.76",
  transform: "translate(-493.9 -12.73)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M933.9,1053.78V727.56s-93.44-1.59-98.19-49.09-9.5-106.11-57.8-106.11-150.44,5.55-150.44-93.43H656s9.5,59.39,43.55,59.39,81.16,2.37,81.16,2.37,78,3.17,78,73.64,15,87.89,75.22,87.89V144.78h24.54v909Z",
  transform: "translate(-493.9 -12.73)"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M968.56,1053.78V462.3c0-47.51,22.17-71.26,62.56-71.26h76s42-6.34,42-45.93V285.73h29.29V353s-5.54,63.35-59.38,63.35h-62.56s-57.8-2.38-57.8,51.46v77.6h197.16s54.24-7.12,54.24-54.24V438.55s2.77-48.3,42.36-48.3,56.22-4.23,56.22-17.42v-38h33.26V372s.79,38.8-38.8,38.8h-33.26c-19.62,0-29.29-.79-29.29,37.22s.35,54.63,0,72.05-22.88,57-83.94,57H997.86v476.67Z",
  transform: "translate(-493.9 -12.73)"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M933.9,508.23s-48.3,2.37-48.3-34.84V408.46s-1.59-51.87-51.87-51.87S783.45,342.74,783.45,334V306.31H750.2v26.13s1.58,51.47,42.76,51.47,64.92,15,64.92,33.26v68.09s7.13,52.26,76,52.26Z",
  transform: "translate(-493.9 -12.73)"
});

var _ref14 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-3",
  cx: 147.6,
  cy: 380.29,
  r: 86.7
});

var _ref15 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-3",
  cx: 275.08,
  cy: 248.85,
  r: 48.7
});

var _ref16 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-3",
  cx: 451.48,
  cy: 92.25,
  r: 43.95
});

var _ref17 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-3",
  cx: 669.84,
  cy: 197.38,
  r: 77.99
});

var _ref18 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-3",
  cx: 870.97,
  cy: 278.94,
  r: 47.9
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M902,1053.78c.79,0,0-384,0-384H628c-38.52,0-76.81-16.63-76.81-91.06h22.17s-10.17,58.59,55.83,55.82,273.13,0,273.13,0V570h32.11v483.79Z",
  transform: "translate(-493.9 -12.73)"
});

var _ref20 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 425.1,
  cy: 529.55,
  r: 39.06
});

var _ref21 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 67.83,
  cy: 501.57,
  r: 67.83
});

function SvgUnnatiTree(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 918.87 1041.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnnatiTree);
export default __webpack_public_path__ + "static/media/UnnatiTree.73fa90b0.svg";
export { ForwardRef as ReactComponent };